import React, { useEffect, useState } from "react";
import {
  IProvisioningSettingsCustomField, IYealinkFirmwares
} from "../interfaces/provisioning";
import DeleteIcon from '@material-ui/icons/Delete';

import VipProvisioningYealinkField from "./VipProvisioningYealinkField";

import { Box, Button, IconButton, Typography } from "@material-ui/core";
import FormGroupAdapter from "./FormGroupAdaptor";
import { Field, Form } from "react-final-form";
export interface IVipProvisioningYealinkWallpaperProps {
  expansionModuleWallpaper:string
  mainScreenWallpaper:string;
  updateField: (field: any, payload: any) => void;
}

export interface IVipProvisioningYealinksState {
  newField?: IProvisioningSettingsCustomField;
  fields: IYealinkFirmwares[];
}

const VipProvisioningYealinkWallpapers = (props:IVipProvisioningYealinkWallpaperProps) => {
  const onFileChangeMain = (sdata: any) => {
    var reader = new FileReader();
    var file = sdata.target.files[0];
    reader.addEventListener("load", function () {
      props.updateField('yealinkMainWallpaper', this.result);
    });
    reader.readAsDataURL(file);
  }

  const onFileChangeExpansion = (sdata: any) => {
    var reader = new FileReader();
    var file = sdata.target.files[0];
    reader.addEventListener("load", function () {
      props.updateField('yealinkExpansionModuleWallpaper', this.result);
    });
    reader.readAsDataURL(file);
  }
  
  return <Form onSubmit={()=>{}} render={()=>{
      return <>
      <div className="form-group">
        <label>Main Screen Wallpaper</label>
        <br />
        <label>The wallpaper for the main screen should be a 480x272 .jpg, .png or .bmp</label>
        {props.mainScreenWallpaper && (
          <>
          <img src={props.mainScreenWallpaper} alt="" />
          <br />
          <Button variant="outlined" onClick={()=>{props.updateField('yealinkMainWallpaper','')}}>Remove Wallpaper</Button>
          </>
        )}
        <br />
        <Field
          accept=".jpg,.png,.bmp"
          buttonLabel="Choose wallpaper..."
          name="yealinkMainWallpaper"
          component={FormGroupAdapter}
          inputOnChange={onFileChangeMain}
          placeholder="Upload image file"
        />
      </div>

      <div className="form-group">
        <label>Expansion Module Wallpaper</label>
        <br />
        <label>The wallpaper for the expansion module should be a 272x480 .jpg, .png or .bmp</label>
        {props.expansionModuleWallpaper && (
          <>
          <img src={props.expansionModuleWallpaper} alt="" />
          <br />
          <Button variant="outlined" onClick={()=>{props.updateField('yealinkExpansionModuleWallpaper','')}}>Remove Wallpaper</Button>
          </>
        )}
        <br />
        <Field
          accept=".jpg,.png,.bmp"
          buttonLabel="Choose wallpaper..."
          name="yealinkExpansionModuleWallpaper"
          component={FormGroupAdapter}
          inputOnChange={onFileChangeExpansion}
          placeholder="Upload image file"
        />
      </div>
    </>
    }}>
    </Form>
}



export default VipProvisioningYealinkWallpapers;